<template>
  <aside class="adArea">
    <div class="adArea_inner u-containar">
      <div class="adBanners">
        <ul class="banenrList">
          <li v-for="(item, i) in bannerList" :key="i">
            <router-link :to="item.link">
              <img :src="item.img" :alt="item.alt" />
            </router-link>
          </li>
        </ul>
      </div>
      <WidgetTwitter />
    </div>
  </aside>
</template>

<script lang="ts">
import WidgetTwitter from '@/components/block/WidgetTwitter.vue'
import { defineComponent } from '@vue/runtime-core'

export default defineComponent({
  name: 'AdArea',

  components: {
    WidgetTwitter
  },

  setup() {
    const bannerList = [
      {
        link: '/guide',
        img: require('@/assets/images/home/footer_banner_guide.png'),
        alt: 'ご利用ガイド'
      },
      {
        link: '/contact/input',
        img: require('@/assets/images/home/footer_banner_contact.png'),
        alt: 'お問い合わせ'
      },
      {
        link: '/lp/services',
        img: require('@/assets/images/home/footer_banner_service.png'),
        alt: '医師向けサービスのご案内'
      },
      {
        link: '/lp/supporters',
        img: require('@/assets/images/home/footer_banner_supporters.png'),
        alt: '医学生サポーター大募集'
      },
      {
        link: '/lp/hpcr',
        img: require('@/assets/images/home/footer_banner_hpcr.jpg'),
        alt: 'ヒポクラ同時会員登録&ご利用ガイド'
      }
      // {
      //   link: '/lp/etc/newregist',
      //   img: require('@/assets/images/home/footer_banner_newregist.png'),
      //   alt:
      //     'マイナビRESIDENT 会員登録キャンペーン 会員登録するだけで全員に500円分のギフトコードプレゼント!'
      // }
    ]

    return {
      bannerList
    }
  }
})
</script>

<style lang="scss">
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.adArea {
  @include mixins.media(md) {
    background-color: var.$color-sub-bg-g;

    &_inner {
      display: flex;
      justify-content: space-between;
      padding-top: 48px;
      padding-bottom: 80px;

      > .twitter {
        padding: 0;
        flex: 0 0 240px;

        @include mixins.media(lg) {
          flex: 0 0 340px;
        }

        .twitter_heading {
          margin-bottom: 14px;
        }
      }
    }
  }
}

.adBanners {
  margin-left: -16px;
  margin-right: -16px;
  padding: 40px 16px;
  background-color: var.$color-secondary;
  overflow: hidden;

  @include mixins.media(md) {
    width: 100%;
    margin: 0 40px 0 0;
    padding: 0;
  }
}

.banenrList {
  display: flex;
  flex-wrap: wrap;
  margin: -3px;

  @include mixins.media(sm) {
    margin: -20px;
  }

  > li {
    flex-basis: calc(50% - 6px);
    margin: 3px;
    border-radius: 5px;
    overflow: hidden;
    @include mixins.media(sm) {
      flex-basis: calc(33.333% - 40px);
      margin: 20px;
    }
    @include mixins.media(lg) {
      flex-basis: calc(25% - 40px);
    }
  }
}
</style>
